<template>
    <div id="clients-components">
        <!-- MODAL AUTORIZAR CONTRATANTE -->
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">
            <modal-stationery
                v-show="modalStationery"
                v-if="modalStationery"
                :supplier_id="itemId"
                :role_id="role_id"
                :folder_id="6"/>

            <modal-notes
                v-show="modalNotes"
                v-if="modalNotes"
                :user_id="user_id"
                :role_id="role_id"
                :supplier_id="itemId"/>

            <modal-monthly-payments
                v-show="modalMonthlyPayments"
                v-if="modalMonthlyPayments"
                :client_id="itemId"
                :role_id="role_id"/>

            <form v-show="modalForm" id="formClient" class="animated fadeIn margin-al-inputs formClient">
                <input type="hidden" name="meses" v-model="clients.meses">
                <div v-if="modificar">
                    <input type="hidden" name="currentName" v-model="clients.currentName">
                    <input type="hidden" name="currentEmail" v-model="clients.currentEmail">
                    <input type="hidden" name="currentUserName" v-model="clients.currentUserName">
                    <input type="hidden" name="currentFile" v-model="clients.currentFile">
                </div>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <div id="fotoUsuarioAdmin">
                            <img v-if="clients.picture" :src="'../storage/clientes/'+clients.picture" alt=""
                                 class="rounded-circle">
                            <img v-else :src="'../images/foto-usuario.jpg'" class="rounded-circle" alt="">
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                        <div class="fotoUploader">
                                <span class="btn btn-file">
                                    Imagen de Perfil <br> <i class="fas fa-upload"></i>
                                    <input type="file"
                                           data-label="avatar"
                                           name="picture"
                                           v-on:change="getLogo"
                                           placeholder="avatar"/>
                                </span>
                            <span class="label-file-papeleria alert alert-info logo"></span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <p class="fotoUploader">
                            Imagen o Logotipo, las imágenes serán escaladas a un tamaño de 300 &times; 300 px, en
                            formato y peso permitido de carga es: <br> <strong>.jpeg, .png, .jpg, .gif, .svg, con un
                            peso maximo de 3mb</strong>
                        </p>
                        <cite>
                            El correo asignado en este formulario se usara para iniciar sesión en el sistema.
                        </cite>
                    </div>
                </div>
                <hr>
                <h2 class="cabeza">Promotores y Agentes</h2>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <select v-model="clients.promoter_id" v-on:change="selectAgents(clients.promoter_id)"
                                data-select="on" class="required" data-name-input="Promotor" name="promoter_id"
                                id="promotor_filtro">
                            <option :value="0">Selecciona un promotor</option>
                            <option v-for="promoter in promoters" :value="promoter.id">
                                {{ promoter.nmPromotor }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-6">
                        <select v-model="clients.agent_id" data-select="on" class="required" data-name-input="Agente"
                                name="agent_id" id="agente_filtro">
                            <option :value="0">Selecciona un agente</option>
                            <option v-for="agent in agents" :value="agent.id">
                                {{ agent.comisionista }}
                            </option>
                        </select>
                    </div>
                </div>
                <h2 class="cabeza">Datos Generales</h2>
                <div class="row">

                    <div class="col-12 col-md-3">
                        <select v-model="clients.tipo_per" id="tipoPer" v-on:change="changeInput(clients.tipo_per)"
                                class="required" data-select="on" data-name-input="Tipo de Persona" name="tipo_per">
                            <option :value="0">Selecciona un tipo de persona</option>
                            <option :value="1">Física</option>
                            <option :value="2">Moral</option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <select v-model="clients.package_id" id="paquete_id_c"
                                v-on:change="selectPlans(clients.package_id)" data-select="on" class="required"
                                data-name-input="Selecciona un Plan" name="package_id">
                            <option :value="0">Selecciona un Plan</option>
                            <option v-for="pack in packages" :value="pack.id">
                                {{ pack.paquete }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <select v-model="clients.kind_plan_id" id="kind_plan_id" data-select="on"
                                data-name-input="Selecciona un tipo de Paquete" name="kind_plan_id" class="required">
                            <option :value="0">Selecciona un tipo de Paquete</option>
                            <option v-for="kind in plans" :value="kind.id">
                                {{ kind.plan }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <select v-model="clients.pago_id" id="planPago" data-select="on" v-on:change="getMonths($event)"
                                data-name-input="Selecciona un plan de pago" class="required" name="pago_id">
                            <option :value="0">Selecciona un plan de pago</option>
                            <option v-for="pago in pagos" :value="pago.id" :data-meses="pago.meses">
                                {{ pago.nombre }}
                            </option>
                        </select>
                        <input type="hidden" v-model="clients.meses" name="meses">
                    </div>

                    <div class="col-12 col-md-3">
                        <select id="estado" v-model="clients.estado" v-on:change="selectCities($event);"
                                data-name-input="Selecciona un estado" name="estado" data-select="on" class="required">
                            <option :value="0">Seleccione un Estado*</option>
                            <option v-for="state in states" :value="state.id" :key="state.id">
                                {{ state.estado }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-3">
                        <select data-select="on" v-model="clients.ciudad" name="ciudad"
                                v-on:change="getSkuClient($event)" data-name-input="Selecciona una ciudad" id="ciudad"
                                class="required">
                            <option :value="0">Selecciona un Ciudad*</option>
                            <option v-for="city in cities" :value="city.cities_id" :key="city.cities_id"
                                    :data-abrv="city.abrv">
                                {{ city.ciudad }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="clients.sku" name="sku" id="sku" type="text"
                               class="al-inputs required scr-input" placeholder="# de contrato GDL-XXXX"/>
                        <label class="scr-supertext" for="sku"># de contrato GDL-XXXX</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="clients.fecha_cont" name="fecha_cont" id="fecha_cont" type="text"
                               class="al-inputs required scr-input" placeholder="F. Inicio de contrato (dd-mm-yyyy)"/>
                        <label class="scr-supertext" for="fecha_cont">F. Inicio de contrato (dd-mm-yyyy)</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="clients.anticipo" name="anticipo" id="anticipo" type="number"
                               class="al-inputs scr-input" placeholder="Anticipo en pesos, sin signo y comas"/>
                        <label for="anticipo" class="scr-supertext">Anticipo en pesos, sin signo y comas</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="clients.num_ap" name="num_ap" id="num_ap" type="text"
                               class="al-inputs scr-input" placeholder="Número de Ap" data-name-input="Numero de Ap"/>
                        <label for="num_ap" class="scr-supertext">Número de Ap</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <select data-select="on" class="required" data-name-input="Status Cliente" name="status"
                                v-model="clients.status" id="status">
                            <option :value="0">Status del Cliente</option>
                            <option :value="1">Activo</option>
                            <option :value="2">Suspendido</option>
                            <option :value="3">Baja</option>
                        </select>
                    </div>

                </div>
                <div class="row">

                    <div class="col-12 col-md-4">
                        <input v-model="clients.nombre" id="nombre" name="nombre" class="al-inputs scr-input"
                               :class="{required: person===true}" type="text" placeholder="Nombre"/>
                        <label class="scr-supertext" for="nombre">Nombre</label>
                    </div>
                    <div class="col-12 col-md-4">
                        <input v-model="clients.paterno" id="paterno" name="paterno" class="al-inputs scr-input"
                               :class="{required: person===true}" type="text" placeholder="Apellido Paterno"/>
                        <label class="scr-supertext" for="paterno">Apellido Paterno</label>
                    </div>
                    <div class="col-12 col-md-4">
                        <input v-model="clients.materno" id="materno" name="materno" class="al-inputs scr-input"
                               :class="{required: person===true}" type="text" placeholder="Apellido Materno"/>
                        <label class="scr-supertext" for="materno">Apellido Materno</label>
                    </div>

                </div>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <input v-model="clients.celular" maxlength="15" id="celular" name="celular"
                               class="al-inputs scr-input" type="tel" placeholder="Celular"/>
                        <label for="celular" class="scr-supertext">Celular</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="clients.telFijo" id="telefono" name="telFijo"
                               class="al-inputs required scr-input" type="tel" placeholder="Telefono"
                               data-name-input="Teléfono"/>
                        <label for="telefono" class="scr-supertext">Telefono</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="clients.email" id="email" name="email" class="al-inputs required scr-input"
                               type="text" placeholder="Correo Electrónico" data-name-input="Correo Electrónico"/>
                        <label for="email" class="scr-supertext">Correo Electrónico</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="clients.fechaNac" maxlength="12" class="al-inputs scr-input" type="text "
                               name="fechaNac" id="fechaNac" placeholder="Fecha Nacimiento (dd-mm-yyyy)">
                        <label for="fechaNac" class="scr-supertext">Fecha Nacimiento</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="clients.calle" id="calle" name="calle" class="al-inputs scr-input" type="text"
                               placeholder="Calle" data-name-input="Calle"/>
                        <label for="calle" class="scr-supertext">Calle</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="clients.numInt" id="numInt" name="numInt" maxlength="15"
                               class="al-inputs scr-input" type="text" placeholder="Número Interior"
                               data-name-input="Número Interior"/>
                        <label for="numInt" class="scr-supertext">Número Interior</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="clients.numExt" id="numExt" name="numExt" maxlength="15"
                               class="al-inputs scr-input" type="text" placeholder="Número Exterior"
                               data-name-input="Número Exterior"/>
                        <label for="numExt" class="scr-supertext">Número Exterior</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="clients.colonia" id="colonia" name="colonia" class="al-inputs scr-input"
                               type="text" placeholder="Colonia" data-name-input="Colonia"/>
                        <label for="colonia" class="scr-supertext">Colonia</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="clients.extension" id="extension" name="extension" class="al-inputs scr-input"
                               type="number" placeholder="Extensión" data-name-input="Extensión"/>
                        <label for="extension" class="scr-supertext">Extensión</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="clients.cp" id="cp" name="cp" class="al-inputs scr-input" type="number"
                               placeholder="Codigo Postal" data-name-input="Codigo Postal"/>
                        <label for="cp" class="scr-supertext">Codigo Postal</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="clients.pais" id="pais" name="pais" class="al-inputs scr-input" type="text"
                               placeholder="País" data-name-input="País"/>
                        <label for="pais" class="scr-supertext">País</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <select v-model="clients.sexo" :disabled="person==false" name="sexo" id="sexo" class=""
                                data-select="on">
                            <option :value="0">Selecciona un sexo</option>
                            <option :value="1">Femenino</option>
                            <option :value="2">Masculino</option>
                        </select>
                    </div>

                </div>
                <h2 class="cabeza">Datos Fiscales</h2>
                <div class="row">
                    <div class="col-12 col-md-3">

                        <select v-model="clients.iva_cont" id="iva" data-select="on"
                                data-name-input="Desglozar I.v.a" name="iva_cont">
                            <option :value="0">Desglozar I.v.a</option>
                            <option :value="1">Si</option>
                            <option :value="2">No</option>
                        </select>

                    </div>

                    <div class="col-12 col-md-3">
                        <select v-model="clients.edo_fiscal" id="edo_fiscal" data-select="on"
                                data-name-input="Estado Fiscal" v-on:change="selectCities($event,true)"
                                name="edo_fiscal">
                            <option :value="0">Selecciona un estado</option>
                            <option v-for="edo in states" :value="edo.id">{{ edo.estado }}</option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <select data-select="on" v-model="clients.cd_fiscal" data-name-input="Ciudad Fiscal"
                                name="cd_fiscal" id="ciudad" class="">
                            <option :value="0">Selecciona un Ciudad*</option>
                            <option v-for="city in citiesFiscales" :value="city.cities_id" :key="city.cities_id">
                                {{ city.ciudad }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="text" name="nmComPerMoral" id="nmComPerMoral" class="al-inputs scr-input"
                               placeholder="Contratante ( Persona Moral )" v-model="clients.nmComPerMoral"/>
                        <label for="nmComPerMoral" class="scr-supertext">Contratante ( Persona Moral )</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="text" name="calle_fiscal" id="calle_fiscal" class="al-inputs scr-input"
                               placeholder="Calle del Dom. Fiscal" v-model="clients.calle_fiscal"/>
                        <label for="calle_fiscal" class="scr-supertext">Calle del Dom. Fiscal</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="text" name="num_int_fiscal" id="num_int_fiscal" maxlength="15"
                               class="al-inputs scr-input" placeholder="Número Interior Dom. Fiscal"
                               v-model="clients.num_int_fiscal"/>
                        <label for="num_int_fiscal" class="scr-supertext">Número Interior Dom. Fiscal</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="text" name="num_ext_fiscal" id="num_ext_fiscal" maxlength="15"
                               class="al-inputs scr-input" placeholder="Número Exterior Dom. Fiscal"
                               v-model="clients.num_ext_fiscal"/>
                        <label for="num_ext_fiscal" class="scr-supertext">Número Exterior Dom. Fiscal</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="text" name="col_fiscal" id="col_fiscal" class="al-inputs scr-input"
                               placeholder="Colonia Dom. Fiscal" v-model="clients.col_fiscal"/>
                        <label for="col_fiscal" class="scr-supertext">Colonia Dom. Fiscal</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="number" name="cp_fiscal" id="cp_fiscal" class="al-inputs scr-input"
                               placeholder="C.p. Dom. Fiscal" v-model="clients.cp_fiscal"/>
                        <label for="cp_fiscal" class="scr-supertext">C.p. Dom. Fiscal</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="text" name="rfc_fiscal" id="rfc_fiscal" class="al-inputs scr-input"
                               placeholder="R.F.C." v-model="clients.rfc_fiscal"/>
                        <label for="rfc_fiscal" class="scr-supertext">R.F.C.</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="tel" name="tel_fijo_fiscal" id="tel_fijo_fiscal" maxlength="15"
                               class="al-inputs scr-input" placeholder="Tel. Fijo Fiscal"
                               v-model="clients.tel_fijo_fiscal"/>
                        <label for="tel_fijo_fiscal" class="scr-supertext">Tel. Fijo Fiscal</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <select v-model="clients.cargo" data-select="on" name="cargo" id="cargo">
                            <option :value="0">Selecciona una Forma de Pago</option>
                            <option :value="1">Cargo a Tarjeta</option>
                            <option :value="2">Pago con Cheque</option>
                            <option :value="3">Transferencia Bancaria</option>
                            <option :value="4">Deposito</option>
                        </select>
                    </div>

                </div>

                <h2 class="cabeza">Representante Legal</h2>
                <div class="row">
                    <div class="col-12 col-md-4">
                        <input id="rep_legal" v-model="clients.rep_legal" name="rep_legal" type="text"
                               class="al-inputs scr-input" placeholder="Nombre*"/>
                        <label for="rep_legal" class="scr-supertext">Nombre*</label>
                    </div>
                    <div class="col-12 col-md-4">
                        <input id="rep_email" v-model="clients.rep_email" name="rep_email" type="text"
                               class="al-inputs scr-input" placeholder="E-mail*"/>
                        <label for="rep_email" class="scr-supertext">E-mail*</label>
                    </div>
                    <div class="col-12 col-md-4">
                        <input id="rep_tel" maxlength="15" v-model="clients.rep_cel" name="rep_cel" type="tel"
                               class="al-inputs scr-input" placeholder="Teléfono*"/>
                        <label for="rep_tel" class="scr-supertext">Teléfono*</label>
                    </div>
                </div>

                <h2 class="cabeza">Datos Bancarios</h2>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <input type="text" name="nom_bco" id="nom_bco" placeholder="Nombre de la persona"
                               class="al-inputs scr-input" v-model="clients.nom_bco">
                        <label for="nom_bco" class="scr-supertext">Nombre de la persona</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="text" maxlength="15" name="banco" id="banco" placeholder="Banco"
                               class="al-inputs scr-input" v-model="clients.banco">
                        <label for="banco" class="scr-supertext">Banco</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="number" name="num_tarjeta" id="cuenta" placeholder="Num. de Tarjeta"
                               class="al-inputs scr-input" v-model="clients.num_tarjeta">
                        <label for="cuenta" class="scr-supertext">Num. de Tarjeta</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="text" maxlength="5" name="vencimiento" id="vencimiento" placeholder="Vencimiento"
                               class="al-inputs scr-input" v-model="clients.vencimiento">
                        <label for="vencimiento" class="scr-supertext">Vencimiento</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="email" name="correo_bco" id="correo_bco" placeholder="Correo"
                               class="al-inputs scr-input" v-model="clients.correo_bco">
                        <label for="correo_bco" class="scr-supertext">Correo</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="text" name="rfc_bco" id="rfc_bco" placeholder="RFC" class="al-inputs scr-input"
                               v-model="clients.rfc_bco">
                        <label for="rfc_bco" class="scr-supertext">RFC</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="tel" name="tel_bco" id="tel_bco" placeholder="Teléfono" class="al-inputs scr-input"
                               v-model="clients.tel_bco">
                        <label for="tel_bco" class="scr-supertext">Teléfono</label>
                    </div>
                </div>
                <h2 class="cabeza">Datos de Autenticación</h2>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <input id="username" name="username" type="text" class="al-inputs scr-input"
                               :class="{required:!modificar}" placeholder="Usuario" v-model="clients.username"/>
                        <label for="username" class="scr-supertext">Usuario</label>
                        <cite v-if="modificar">
                            Este campo esta habilitado para hacer un cambio de usuario. La misma que se usa para iniciar
                            sesión.
                        </cite>
                    </div>
                    <div class="col-12 col-md-3">
                        <input id="pass" name="password" type="password" class="al-inputs scr-input"
                               :class="{required:!modificar}" placeholder="Contraseña" v-model="clients.password"/>
                        <label for="pass" class="scr-supertext">Contraseña</label>
                        <cite v-if="modificar">
                            Este campo esta habilitado para hacer un cambio de contraseña. La misma que se usa para
                            iniciar sesión.
                        </cite>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <button id="dyn-button" type="button" class="btn btn-primary" v-on:click="guardar()">Guardar
                        </button>
                    </div>
                </div>
            </form>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <b-pagination
                                pills
                                align="fill"
                                :hide-goto-end-buttons="true"
                                :limit="3" v-model="pagination.current_page" :total-rows="pagination.total"
                                :per-page="pagination.per_page" aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-2 mb-3 mb-sm-0">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">{{
                                    tituloBtn
                                }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="pagination.data" :filter="filter">
                            <template #head(Acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #cell(Cliente)="{item}">
                                        <span v-if="item.tipo_per==1">
                                            {{ item.nombre }} {{ item.paterno }} {{ item.materno }}
                                        </span>
                                <span v-else> {{ item.nmComPerMoral }}</span>
                            </template>
                            <template #cell(Plan)="{item}">
                                         <span v-if="item.relpackage" class="badge rounded-pill text-bg-teal">
                                            {{ item.relpackage.paquete }}
                                         </span>
                            </template>
                            <template #cell(Paquete)="{item}">
                                         <span v-if="item.relplanes" class="badge rounded-pill text-bg-purple">
                                             {{ item.relplanes.plan }}
                                         </span>
                            </template>
                            <template #cell(Sku)="{item}">
                                {{ item.sku }}
                            </template>
                            <template #cell(Proceso)="{item}">
                                            <span v-if="item.approved_at==''" class="badge rounded-pill text-bg-danger"><i
                                                class="fa-solid fa-circle-exclamation"></i></span>
                                <span v-else class="badge rounded-pill text-bg-success"><i
                                    class="fa-solid fa-circle-check"></i></span>
                            </template>
                            <template #cell(Agente)="{item}">
                                            <span v-if="item.relagent">
                                            {{ item.relagent.comisionista }}
                                                </span>
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" v-if="role_id===1 && item.payments.length>0"
                                           href="javascript:void(0)"
                                           v-on:click="itemId=item.id; openModalsProviders('monthly_payments')">Mensualidades</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true; updateReg(item)">Editar</a>
                                        <a class="dropdown-item" v-if="role_id===1" href="javascript:void(0)"
                                           v-on:click="itemId=item.id; openModalsProviders('note')">Agregar Nota</a>
                                        <a class="dropdown-item" v-if="role_id===1" href="javascript:void(0)"
                                           v-on:click="itemId=item.id; openModalsProviders('stationery')">Subir
                                            Papelería</a>
                                        <a class="dropdown-item" v-if="item.approved_at==null"
                                           href="javascript:void(0)">Autorizar</a>
                                        <a class="dropdown-item" :href="'/afiliados-titulares/'+item.sku">Afiliados
                                            Titulares</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Cargando...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col-xl-2">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                          v-model="pagination.current_page" :total-rows="pagination.total"
                                          :per-page="pagination.per_page" aria-controls="my-table"
                                          v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {estadoService} from "../../Services/States.service";
import {statescitiesService} from "../../Services/Statescities.service";
import {promotersService} from "../../Services/Promoters.service";
import {agentsService} from "../../Services/Agents.service";
import {clientsService} from "../../Services/Clients.service";
import {packagesService} from "../../Services/Packages.service";
import {paymentplanService} from "../../Services/Paymentplan.service";
import {getFormData} from "../../Utils/getDataForm";
import {plansService} from "../../Services/Plans.service";

export default {
    name: "clients",
    mixins: [myMixins],
    props: {
        user_id: {
            type: Number,
            default: 0
        },
        role_id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            show: false,
            isBusy: false,
            modificar: false,
            person: false,
            filter: null,
            rowID: 0,
            clients: {
                id: 0,
                tipo_per: 0,
                package_id: 0,
                kind_plan_id: 0,
                promoter_id: 0,
                agent_id: 0,
                user_id: '',
                quoting_id: '',
                pago_id: 0,
                nombre: '',
                paterno: '',
                materno: '',
                fechaNac: '',
                calle: '',
                numInt: '',
                numExt: '',
                colonia: '',
                cp: '',
                estado: 0,
                ciudad: 0,
                pais: '',
                email: '',
                celular: '',
                telFijo: '',
                extension: '',
                sexo: 0,
                iva_cont: 0,
                nmComPerMoral: '',
                calle_fiscal: '',
                num_int_fiscal: '',
                num_ext_fiscal: '',
                col_fiscal: '',
                cp_fiscal: '',
                edo_fiscal: 0,
                cd_fiscal: 0,
                tel_fijo_fiscal: '',
                rfc_fiscal: '',
                rep_legal: '',
                rep_cel: '',
                rep_email: '',
                num_ap: '',
                meses: '',
                cargo: 0,
                banco: '',
                num_tarjeta: '',
                vencimiento: '',
                picture: '',
                sku: '',
                fecha_cont: '',
                status: '',
                pdf: '',
                anticipo: '',
                approved_at: '',
                canceled_at: '',
                username: '',
                password: '',
                currentName: '',
                currentEmail: '',
                currentUserName: '',
                currentFile: '',
            },
            params: {
                limit: 10,
                page: 1,
            },
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            fields: [
                {key: 'Cliente'},
                {key: 'Plan'},
                {key: 'Paquete'},
                {key: 'Sku'},
                {key: 'Proceso'},
                {key: 'Agente'},
                {key: 'Acciones'}
            ],
            states: [],
            cities: [],
            citiesFiscales: [],
            promoters: [],
            agents: [],
            packages: [],
            plans: [],
            pagos: [],
            tituloBtn: 'Agregar',
            itemId: 0,
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await clientsService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formClient');
            if (respVal) {
                this.disableSubmitBtn(true);
                const formData = getFormData('formClient');
                if (this.modificar) {
                    //console.log('update');
                    resp = await clientsService.updateOne(this.clients.id, formData, {isForm: true});
                } else {
                    resp = await clientsService.saveOne(formData, {isForm: true});
                }
                this.modificar = false;
                this.getAlert(resp.process);
                this.showModal = false;
                this.setEmpty();
                await this.index();
                this.disableSubmitBtn(false);
            }
        },
        async index() {
            this.isBusy = true;
            this.pagination = await clientsService.getMany(this.params);
            this.states = await estadoService.getMany({limit: 0});
            this.promoters = await promotersService.getMany({limit: 0});
            this.packages = await packagesService.getMany({limit: 0});
            this.pagos = await paymentplanService.getMany({limit: 0});
            this.isBusy = false;
        },
        async selectAgents(promoter_id) {
            this.agents = await agentsService.getAgentByPromoterId(promoter_id);
        },
        async selectCities($e, kind_selected = false) {

            let state_id = this.stateId($e);

            switch (kind_selected) {
                case true:
                    this.citiesFiscales = await statescitiesService.getCitiesByState(state_id);
                    break;
                default:
                    this.cities = await statescitiesService.getCitiesByState(state_id);
                    break;
            }

        },
        async selectPlans(package_selected) {
            this.plans = await plansService.getPlansByPackage(package_selected);
        },
        async getSkuClient($e) {
            //console.log('ABRV = ' + $e.target.options[$e.target.options.selectedIndex].getAttribute('data-abrv'));
            let abrv = $e.target.options[$e.target.options.selectedIndex].getAttribute('data-abrv');
            if (abrv !== null) {
                this.clients.sku = await clientsService.getSkuClient(abrv);
            } else {
                this.getAlert('not_found', '');
            }
        },
        getMonths($e) {
            this.clients.meses = $e.target.options[$e.target.options.selectedIndex].getAttribute('data-meses');
        },
        changeInput(value) {
            switch (value) {
                case 1:
                    this.person = true;
                    break;
                default:
                    this.person = false;
                    break;
            }
        },
        updateReg(data = {}) {
            if (this.modificar) {
                //console.log('fecha_cont', data.payments[0].fecha);
                this.tituloBtn = 'Actualizar';
                this.clients = data;
                this.selectPlans(data.package_id);
                this.selectAgents(data.promoter_id);
                this.selectCities(data.estado);
                this.selectCities(data.edo_fiscal, true);
                if (data.payments.length > 0) {
                    this.clients.fecha_cont = data.payments[0].fecha;
                }
                this.clients.estado = data.estado;
                this.clients.cuidad = data.ciudad;
                this.clients.cd_fiscal = data.cd_fiscal;
                this.clients.edo_fiscal = data.edo_fiscal;
                this.clients.currentName = data.nombre + ' ' + data.paterno + ' ' + data.materno;
                if (data.reluser) {
                    this.clients.correo = data.reluser.email;
                    this.clients.currentEmail = data.reluser.email;
                    this.clients.currentUserName = data.reluser.username;
                    this.clients.username = data.reluser.username;
                } else {
                    this.clients.currentEmail = data.email;
                }
                this.clients.currentFile = data.picture;
                this.openModalsProviders();
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        getLogo(event) {
            this.getNameFile(event, 'logo');
        },
        setEmpty() {
            this.client = {
                id: 0,
                tipo_per: 0,
                package_id: 0,
                kind_plan_id: 0,
                promoter_id: 0,
                agent_id: 0,
                user_id: '',
                quoting_id: '',
                pago_id: 0,
                nombre: '',
                paterno: '',
                materno: '',
                fechaNac: '',
                calle: '',
                numInt: '',
                numExt: '',
                colonia: '',
                cp: '',
                estado: 0,
                ciudad: 0,
                pais: '',
                email: '',
                celular: '',
                telFijo: '',
                extension: '',
                sexo: 0,
                iva_cont: 0,
                nmComPerMoral: '',
                calle_fiscal: '',
                num_int_fiscal: '',
                num_ext_fiscal: '',
                col_fiscal: '',
                cp_fiscal: '',
                edo_fiscal: 0,
                cd_fiscal: 0,
                tel_fijo_fiscal: '',
                rfc_fiscal: '',
                rep_legal: '',
                rep_cel: '',
                rep_email: '',
                num_ap: '',
                meses: '',
                cargo: 0,
                banco: '',
                num_tarjeta: '',
                vencimiento: '',
                picture: '',
                sku: '',
                fecha_cont: '',
                status: '',
                pdf: '',
                anticipo: '',
                num_titulares: '',
                num_dependientes: '',
                num_asegurados: '',
                p_basica: '',
                descuento: '',
                gtos_admin: '',
                a_p: '',
                subtotal: '',
                iva: '',
                prima_total: '',
                financiamiento: '',
                approved_at: '',
                canceled_at: '',
                username: '',
                password: '',
                currentName: '',
                currentEmail: '',
                currentUserName: '',
                currentFile: '',
            }
        }
    },
    mounted() {
        this.index();
    }
}
</script>
